import defaultValue from "./assessmentSlice";

export default defaultValue;
export * from "./assessmentSlice";
